import styled from 'styled-components';

import { LegacyButton as Button } from 'components/Button/LegacyButton';
import { colors, transition } from 'theme';

export const CloseButton = styled(Button)`
  color: ${colors.lightContentGrey};
  transition: all ${transition};
  &:hover {
    color: ${colors.brandBlue};
  }
`;
